import { render } from "./MainFooter.vue?vue&type=template&id=218ec2d2&scoped=true"
const script = {}

import "./MainFooter.vue?vue&type=style&index=0&id=218ec2d2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-218ec2d2"]])

export default __exports__